import { useSnackbar } from 'notistack';

/**
 * Enum for toast types. These comes directly from notistack's variant prop. See [notistack docs]{@link https://notistack.com/api-reference#snackbarprovider-props}
 * @type {{SUCCESS: string, ERROR: string, INFO: string, WARNING: string, DEFAULT: string}}
 */
export const TOAST_TYPE = {
  DEFAULT: 'default',
  SUCCESS: 'success',
  INFO: 'info',
  ERROR: 'error',
  WARNING: 'warning',
};

/**
 * Custom hook to show toast notifications. A wrapper around notistack's enqueueSnackbar function.
 * @returns {object} - showToast function
 */
const useToast = () => {
  const { enqueueSnackbar } = useSnackbar();

  const showToast = (variant, message) => {
    enqueueSnackbar(message, { variant });
  };

  return { showToast };
};

export default useToast;
